export default "__VITE_ASSET__132cf800__"